import React from 'react';
import { homeBreadcrumb } from 'slovlex-idsk-react-components';
import routes from '../routing/routes';
import { BreadcrumbRouteProps } from '../types/BreadcrumbRouteProps';

const getBreadcrumbPrefixArray = (
  type = '',
  year = null,
  index = null,
  isHromadna = false,
): Array<BreadcrumbRouteProps> => (
  [homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
    {
      heading: type === 'PI' ? routes.predbeznaInformacia.list.name : routes.procesy.list.name,
      to: process.env.REACT_APP_PORTAL_MAIN_URL
        + (type === 'PI' ? routes.predbeznaInformacia.list.to : routes.procesy.list.to),
      // SLASLX-3400 (T): absolute `to` would otherwise navigate the iframe to
      // portal-main, rendering its chrome inside the existing iframe → header
      // in header. preventDefault keeps navigation in postMessage only.
      onClick: (e?: React.MouseEvent) => {
        e?.preventDefault();
        window.parent.postMessage({
          type: 'iframe-to-parent-external-route',
          route: type === 'PI' ? routes.predbeznaInformacia.list.to : routes.procesy.list.to,
        }, '*');
      },
    },
    {
      heading: routes.procesy.detail.name(type, year, index),
      to: process.env.REACT_APP_PORTAL_MAIN_URL + routes.procesy.detail.withParams(type, year, index),
      onClick: (e?: React.MouseEvent) => {
        e?.preventDefault();
        window.parent.postMessage({
          type: 'iframe-to-parent-external-route',
          route: routes.procesy.detail.withParams(type, year, index),
        }, '*');
      },
    },
    {
      heading: isHromadna ? routes.hromadnePripomienky.list.name
        : routes.pripomienky.list.name,
      to: isHromadna ? routes.hromadnePripomienky.list.withParams(type, year, index)
        : routes.pripomienky.list.withParams(type, year, index),
    }]
);

export default getBreadcrumbPrefixArray;
